import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/laugh-beam': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM389.4 397.4c37.8-37.8 58.6-88 58.6-141.4s-20.8-103.6-58.6-141.4c-37.8-37.8-88-58.6-141.4-58.6s-103.6 20.8-141.4 58.6c-37.8 37.8-58.6 88-58.6 141.4s20.8 103.6 58.6 141.4c37.8 37.8 88 58.6 141.4 58.6s103.6-20.8 141.4-58.6zM328 152c23.8 0 52.7 29.3 55.8 71.4 0.7 8.5-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6-12.3 0-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.4-15.6 4.1-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4zM127 227.9c-4.2 7.4-15.7 4-15.1-4.5 3.3-42.1 32.2-71.4 56-71.4 23.8 0 52.7 29.3 56 71.4 0.7 8.5-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6zM362.4 288c8.2 0 14.5 7 13.5 15-7.5 59.2-58.9 105-121.1 105h-13.6c-62.2 0-113.6-45.8-121.1-105-1-8 5.3-15 13.5-15h228.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/regular/laugh-beam.js
// module id = 483
// module chunks = 0